import React from 'react';
import classNames from 'classnames';

import IconEmenu from '@zvuk-b2b/react-uikit/ui/icons/Emenu';

import styles from './index.module.scss';

interface EmenuPlaceholderProps {
  className?: string;
  iconClassName?: string;
}

const EmenuPlaceholder: React.FC<EmenuPlaceholderProps> = ({ className, iconClassName }) => (
  <div className={classNames(styles.placeholder, className)}>
    <IconEmenu className={classNames(styles.icon, iconClassName)} />
  </div>
);

export default EmenuPlaceholder;
